import React, { useState } from 'react';
import { Button, Dialog, FormHelperText, Grid, Icon, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Scrollbars from 'rc-scrollbars';
import DialogLoader from '../../../components/Loader/DialogLoader';
import { InputBaseField } from '../../../components/InputField/InputField';
import { DraggableComponent } from '../../../components/UiElements/UiElements';
import { withSnackbar } from '../../../components/Message/Alert';
import { PostDataAPI } from '../../../Services/APIService';
import useStyles from '../addInventory/styles';

function UnassignDevice({ dialogOpenClose, handleClose, handleSuccessClose, device, showMessage, ...props }) {
    const classes = useStyles();
    const [reason, setReason] = useState('');
    const [reasonError, setReasonError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleReasonChange = (event) => {
        setReason(event.target.value);
        if (event.target.value.trim()) {
            setReasonError(false);
        }
    };

    const unassignDevice = () => {
        if (isLoading) {
            return;
        }

        const trimmedReason = reason.trim();
        if (!trimmedReason) {
            setReasonError(true);
            return;
        }

        const request = {
            deviceId: device.deviceId,
            reason: trimmedReason,
        };

        setIsLoading(true);
        PostDataAPI('deviceinventory/unassignDevice', request, true).then(result => {
            setIsLoading(false);
            if (result.success) {
                setReason('');
                setReasonError(false);
                handleSuccessClose(result.message || 'Device unassigned successfully.');
            } else {
                showMessage('Error', result.message || 'Error unassigning device, please contact administrator', 'error', 3000);
            }
        }).catch(() => {
            setIsLoading(false);
            showMessage('Error', 'Error unassigning device, please contact administrator', 'error', 3000);
        });
    };

    return (
        <Dialog
            classes={{ paper: classes.dialogPaper }}
            PaperComponent={DraggableComponent}
            disableBackdropClick
            disableEscapeKeyDown
            open={dialogOpenClose}
            maxWidth="md"
            {...props}
        >
            <div className={classes.dialogContent}>
                {isLoading ? <DialogLoader /> : ''}
                <div className={classes.box}>
                    <div className={classes.header} id="draggable-dialog-title">
                        <Typography className={classes.title}>Unassign Device</Typography>
                        <Icon className={classes.closeIcon} onClick={isLoading ? undefined : handleClose} color="primary"><CloseIcon /></Icon>
                    </div>
                    <Scrollbars autoHeight autoHeightMax={570}>
                        <div className={classes.content}>
                            <div className={classes.unassignConfirmation}>
                                <Typography className={classes.unassignMessage}>Are you sure you want to unassign this device?</Typography>
                                <Typography className={classes.unassignImei}><span>IMEI:</span> {device.imei1 || '-'}</Typography>
                            </div>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Typography className={classes.unassignReasonLabel}>Reason <span>*</span></Typography>
                                    <InputBaseField
                                        name="reason"
                                        value={reason}
                                        onChange={handleReasonChange}
                                        placeholder="Please provide a reason"
                                        type="text"
                                        MaxLength={500}
                                        IsDisabled={isLoading}
                                    />
                                    {reasonError ? <FormHelperText className={classes.errorText}>Please enter reason</FormHelperText> : ''}
                                </Grid>
                            </Grid>
                        </div>
                    </Scrollbars>
                    <div className={classes.footer}>
                        <div className={classes.footerRight}>
                            <Button className={classes.backBtn} disabled={isLoading} onClick={handleClose}>Cancel</Button>
                            <Button className={classes.changeBtn} disabled={isLoading} onClick={unassignDevice}>Unassign</Button>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
    );
}

export default withSnackbar(UnassignDevice);
